export enum ARClaimLogEnum {
  DXAttachment     = '00000272-1000-0000-0000-000000000001',
  DXEncodedClaim   = '00000272-1000-0000-0000-000000000002',
  Trace            = '00000272-1000-0000-0000-000000000003',
  Error            = '00000272-1000-0000-0000-000000000004',
}
